import { AppComponentBase } from 'shared/app-component-base';
import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import { AppConsts } from './AppConsts';
import { FieldComparatorEnum, FieldTypeEnum, OrderDirectionEnum } from './AppEnums';
import { FilterFieldEntryDto } from './service-proxies/service-proxies';

export class PagedResultDto {
  items: any[];
  totalCount: number;
}

export class EntityDto {
  id: number;
}

export class PagedRequestDto {
  skipCount: number;
  maxResultCount: number;
}

export class PagedCommonResultRequestDto extends PagedRequestDto {
  keyword: string;
}

export class PagedActiveResultRequestDto extends PagedCommonResultRequestDto {
  isActive: boolean | null;
}

export class PagedNaturalPersonResultRequestDto extends PagedCommonResultRequestDto {
    fullName: string | null;
    phoneNumber: string | null;
    emailAddress: string | null;
}

export class PagedJuridicalPersonResultRequestDto extends PagedCommonResultRequestDto {
    name: string | null;
    taxID: string | null;
    emailAddress: string | null;
}

export class PagedPersonCompanyRoleDataResultRequestDto extends PagedCommonResultRequestDto {
    companyId: number;
    companyRoleId: number;
    showAllTenants: boolean;
}

export class PagedNaturalPersonAttorneysInFactResultRequestDto extends PagedCommonResultRequestDto {
    personId: number;
    from: boolean;
}

export class PagedJuridicalPersonAttorneysInFactResultRequestDto extends PagedCommonResultRequestDto {
    personId: number;
    from: boolean;
}

export class PagedCompanyResultRequestDto extends PagedCommonResultRequestDto {
  showAllTenants: boolean;
}

export class PagedAssignableJuridicalPersonResultRequestDto extends PagedCommonResultRequestDto {
  juridicalPersonId: number | null;
}

@Component({
  template: ''
})
export abstract class PagedListingComponentBase<TEntityDto> extends AppComponentBase implements OnInit, AfterViewInit {

  public pageSize = AppConsts.pageSize;
  public pageNumber = 1;
  public totalPages = 1;
  public totalItems: number;
  public isTableLoading = false;
  public orderField = '';
  public orderDirection: number = OrderDirectionEnum.Ascending;
  public filters: FilterFieldEntryDto[] = [];

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    this.refresh();
  }

  ngAfterViewInit() {
    this.cd.detectChanges();
  }

  refresh(): void {
    this.getDataPage(this.pageNumber);
  }

  // ORDERING
  order(orderField: string) {
    this.orderDirection = this.orderField == orderField ?
      this.orderDirection == OrderDirectionEnum.Ascending ?
        OrderDirectionEnum.Descending : OrderDirectionEnum.Ascending
      : OrderDirectionEnum.Ascending;
    this.orderField = orderField;
    this.refresh();
  }

  // FILTERING
  addFilter(fieldName: string, filterValue: string, fieldType = FieldTypeEnum.String, fieldComparator = FieldComparatorEnum.Equals) {
    // Check if we already have the filter added so we update it
    this.removeFilter(fieldName);

    // Add the filter
    const filter = new FilterFieldEntryDto();
    filter.fieldName = fieldName;
    filter.value = filterValue;
    filter.fieldType = <number>fieldType;
    filter.fieldComparator = <number>fieldComparator;
    this.filters.push(filter);

    this.refresh();
  }

  removeFilter(fieldName: string) {
    const index = this.filters.findIndex(x => x.fieldName == fieldName);
    if (index !== -1) { this.filters.splice(index, 1); }
  }

  getFilterValue(fieldName: string) {
    const index = this.filters.findIndex(x => x.fieldName == fieldName);
    if (index === -1) { return ''; }

    return this.filters[index].value;
  }

  clearFilters() {
    this.filters = [];
    this.refresh();
  }

  public showPaging(result: PagedResultDto, pageNumber: number): void {
    this.totalPages = ((result.totalCount - (result.totalCount % this.pageSize)) / this.pageSize) + 1;

    this.totalItems = result.totalCount;
    this.pageNumber = pageNumber;
  }

  public getDataPage(page: number): void {
    const req = new PagedRequestDto();
    req.maxResultCount = this.pageSize;
    req.skipCount = (page - 1) * this.pageSize;

    if (req.skipCount < 0) { req.skipCount = 0; }

    this.isTableLoading = true;
    this.list(req, page, () => {
        this.isTableLoading = false;
    });
  }

  public isKeywordClean(keyword: string) {
    if (keyword === '') {
      this.getDataPage(1);
    }
  }

  protected abstract list(request: PagedRequestDto, pageNumber: number, finishedCallback: Function): void;
  protected abstract delete(entity: TEntityDto): void;
}
